import React from 'react';
import { unicornCase } from '@cryptosheets/util';
import _ from 'lodash';
import { Drawer, Typography } from 'antd';
var {
  Link,
  Paragraph,
  Title
} = Typography;
export default function DocsEndpointParameters(_ref) {
  var {
    endpoint,
    drawerVisible,
    closeDrawer
  } = _ref;
  var {
    name
  } = endpoint;

  var providerName = _.get(endpoint, ['provider', 'name'], 'provider');

  var endpointDocumentation = "https://docs.cryptosheets.com/providers/".concat(unicornCase(providerName), "/").concat(unicornCase(name), "/#example-parameters");
  return /*#__PURE__*/React.createElement(Drawer, {
    title: "Endpoint Parameters",
    placement: "right",
    closable: true,
    onClose: closeDrawer,
    visible: drawerVisible
  }, /*#__PURE__*/React.createElement(Paragraph, null, "Learn how to use the ".concat(name, " endpoint from ").concat(providerName, ".")), /*#__PURE__*/React.createElement(Title, {
    level: 4
  }, "Additional Resources"), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "".concat(endpointDocumentation),
    target: "_blank"
  }, "Link to documentation")))), endpoint.graphql && /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement(Title, {
    level: 4
  }, "GraphQL Resources"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://docs.cryptosheets.com/cryptosheets-concepts/graphql",
    target: "_blank"
  }, "Link to GraphQL API documentation")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://docs.cryptosheets.com/cryptosheets-concepts/graphql/tutorials",
    target: "_blank"
  }, "Link to GraphQL API Tutorials")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://docs.cryptosheets.com/cryptosheets-concepts/graphql/examples",
    target: "_blank"
  }, "Link to GraphQL API Examples")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://docs.cryptosheets.com/cryptosheets-concepts/graphql/advanced",
    target: "_blank"
  }, "Link to GraphQL API Advanced Concepts")))));
}